import VisibilityIcon from '@mui/icons-material/Visibility'
import ClearIcon from '@mui/icons-material/Clear'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import { Popover, IconButton, Tooltip } from '@mui/material'
import {
  useCreateTipoBimLinkProyecto,
  useUpdateTipoBimLink,
} from 'lib/react-query/queriesTipoBimLinkProyectos'
import { CustomButton } from 'components/ui'
import { CustomButtonWithTooltip } from 'components/ui/CustomButton'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { IconEye, IconEyeOff } from 'lib/icons/Icon'


const ButtonsTipoConfigItem = ({ tipoBimlink, isHide, name, externalIds }) => {
  const { idProject } = useParams()
  const { mutateAsync } = useCreateTipoBimLinkProyecto()
  const { mutateAsync: updateTipo } = useUpdateTipoBimLink()


  const changeVisibilityTipo = visible => {
    if (!tipoBimlink) {
      const b = {
        name,
        proyecto: idProject,
        tipoExternalId: externalIds,
        visible,
      }
      mutateAsync(b)
    } else {
      const body = { visible, tipoExternalId: externalIds }
      updateTipo({ body, id: tipoBimlink._id })
    }
  }

  const removeArticulo = () => {
    updateTipo({ body: { bimlink: null }, id: tipoBimlink._id })
  }

  return (
    <div className="group-btn" style={{ display: 'flex', justifyContent: 'flex-end' }}>
      {tipoBimlink?.bimlink && (
        <PopupState variant="popover" popupId="pop-over-delete-tipo">
          {popupState => (
            <div>
              <Tooltip
                  title="Eliminar Artículo"
                  placement="right-end"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: '9px', 
                        padding: '4px',    
                      },
                    },
                  }}
                >
                  <IconButton onClick={e => e.stopPropagation()}>
                    <ClearIcon {...bindTrigger(popupState)} />
                  </IconButton>
                </Tooltip>

              <Popover
                {...bindPopover(popupState)}
                onClick={e => e.stopPropagation()}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'center',
                  horizontal: 'left',
                }}
              >
                <div style={{ padding: '1rem' }}>
                  <p style={{ fontSize: '1.2rem' }}>
                    ¿Estás seguro que quieres desvincular el Bimlink de este tipo?
                  </p>
                  <div className="popover-container">
                    <CustomButton
                      type="primary"
                      className="button-popover"
                      onClick={() => popupState.setOpen(false)}
                    >
                      No
                    </CustomButton>
                    <CustomButton
                      type="secondary"
                      className="button-popover"
                      onClick={() => {
                        popupState.setOpen(false)
                        removeArticulo()
                      }}
                    >
                      Sí
                    </CustomButton>
                  </div>
                </div>
              </Popover>
            </div>
          )}
        </PopupState>
      )}
      {isHide ? (
        <CustomButtonWithTooltip
          classname="show-tipo"
          onClick={() => changeVisibilityTipo(true)}
          Icon={ <IconEyeOff style={{ fontSize: '15px', color: 'grey'}} />}
          title="Mostrar tipo"
        />
      ) : (
        <CustomButtonWithTooltip
          classname="hide-tipo"
          onClick={() => changeVisibilityTipo(false)}
          Icon={<IconEye style={{ fontSize: '13px' }}/>}
          title="Ocultar tipo"
        />
      )}
    </div>
  )
}

export default ButtonsTipoConfigItem
